 <!-- <ng-lottie  [options]="optionsBackdrop"  id="backdrop" class="ipm-diwali-animation"></ng-lottie> -->
<div class="ipm-payment-success-pop">
    <canvas ipmFireworks class="ipm-payment-fireworks" *ngIf="showDiwaliAnimation" aria-hidden="true"></canvas>
    <div class="ipm-payment-success-body">
        <div class="ipm-animation-section">
             <ng-lottie  [options]="options"  id="messageIcon"></ng-lottie>
        </div>
        <p class="ipm-sub-heading">
            <span [innerHTML]="message" id="messageIcon"></span>
        </p>

        <div class="actions ipm-actions" *ngIf="isShowButton">
            <button color="primary" class="btn ipm-submit-btn close-button-primary" 
                type="submit"
                (click)="close('emit')">
                {{ buttonText}} 
            </button>
        </div>
    </div>
</div>
